module.exports = __webpack_public_path__ + "img/paint-bucket.e7d1079a.svg";